import { BackButton, SubmitButton } from "@design-system/components/Button";
import { EmailInput } from "@design-system/components/Form";
import { useForgetPassword } from "@framework/auth/hooks";
import { trans, plainTrans } from "@mongez/localization";
import { Form } from "@mongez/react-form";

export function ForgotPasswordForm() {
  const forgetPasswordSubmit = useForgetPassword();

  return (
    <div className="w-full space-y-8">
      <BackButton />
      <div className="space-y-1.5">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{trans("auth.forgotPassword")}</h2>
        <p className="text-sm text-muted-foreground dark:text-gray-300">
          {trans("auth.enterEmail")}
        </p>
      </div>

      <Form onSubmit={forgetPasswordSubmit} className="space-y-6">
        <div className="space-y-4">
          <EmailInput
            name="email"
            label={trans("auth.email")}
            placeholder={plainTrans("auth.emailPlaceholder")}
            required
          />
        </div>
        <div className="space-y-4">
          <SubmitButton className="h-11 w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700">
            {trans("auth.verifyEmail")}
          </SubmitButton>
        </div>
      </Form>
    </div>
  );
}
